import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

import type { RootState } from 'store/store'

import { EmbedTokenResponse } from '../types'

export interface DashboardState {
  embedToken: EmbedTokenResponse
  selectedOrgInDomo: { id: string; name: string }[]
  organizationList: { id: string; name: string }[]
}
const initialState: DashboardState = {
  embedToken: {
    accessToken: undefined,
  },
  selectedOrgInDomo: [],
  organizationList: [],
}

// slice
export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setDomoEmbedToken(state, action) {
      state.embedToken = action.payload
    },
    setSelectedOrgInDomo(state, action) {
      state.selectedOrgInDomo = action.payload
    },
    setOrganizationList(state, action) {
      state.organizationList = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(PURGE, () => initialState)
  },
})

// Actions
export const dashboardActions = {
  setDomoEmbedToken: dashboardSlice.actions.setDomoEmbedToken,
  setOrganizationList: dashboardSlice.actions.setOrganizationList,
}

// Selectors
export const getEmbedToken = (state: RootState) => state.dashboard?.embedToken
export const getSelectedOrgInDomo = (state: RootState) => state.dashboard?.selectedOrgInDomo
export const getOrganizationList = (state: RootState) => state.dashboard?.organizationList

export const { setSelectedOrgInDomo } = dashboardSlice.actions

// Reducer
export default dashboardSlice.reducer
